import React, { useRef, useState, useEffect } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { add, update } from "../../service/industryService";
import { Button } from "primereact/button";
import { templateAdd, templateUpdate } from "../../service/templateService";
import { Grid } from "@mui/material";
import { InputText } from "primereact/inputtext";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { Editor } from "primereact/editor";
import { QuillEditor } from "../../components/QuillEditor";

export default function PoliciesProceduresAdd(modalProps: any) {
  const record = modalProps.record;

  const [name, setName] = useState(record?.name || "");
  const [content, setContent] = useState(record?.content || "");
  const [industry, setIndustry] = useState(record?.industry || []);
  const [jobTask, setJobTask] = useState(
    record?.job_task || []
  );

  const quillEditorRef = useRef();
  const [placeholderErrors, setPlaceholderErrors] = useState<string[]>([]);

  const validateForm = async () => {
    //@ts-ignore
    const formValid = quillEditorRef.current?.validate();
    if (formValid?.hasPlaceholderErrors?.length > 0) {
      setPlaceholderErrors(formValid.hasPlaceholderErrors);
    } else {
      setPlaceholderErrors([]);
    }
  };

  // Validate on content change with debounce
  useEffect(() => {
    const debounceValidation = setTimeout(() => {
      validateForm();
    }, 1000);

    return () => clearTimeout(debounceValidation); // Cleanup on value change
  }, [content]);



  async function addIndustry() {
    if (!name || name.trim() === "") {
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Please enter a name",
        life: 3000,
      });
      return;
    }

    //@ts-ignore
    const formValid = quillEditorRef.current?.validate();
    
    if (formValid?.hasPlaceholderErrors?.length > 0) {
      setPlaceholderErrors(formValid.hasPlaceholderErrors);
      modalProps.toast.current.show({
        severity: "warn",
        summary: "Fix placeholder errors before saving",
        life: 3000,
      });
      return;
    }

    const updateObject = {
      name: name,
      industry,
      job_task: jobTask,
      content,
    };
    if (record?.id) {
      templateUpdate(record.id, updateObject).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Policies & Procedures Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      templateAdd(updateObject).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Policies & Procedures Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl sx={{ flexGrow: 1 }}>
            <FormLabel>
              Name<div style={{ color: "red" }}>*</div>
            </FormLabel>
            <FormControl
              sx={{
                display: { sm: "flex-column", md: "flex-row" },
                gap: 2,
              }}
            >
              <InputText
                value={name}
                onChange={(e) => setName(e.target.value)}
                type="text"
                className="p-inputtext-sm PrimeSmallInput"
              />
            </FormControl>
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <MultiDropdownApi
            showAll={true}
            apiPath="industry"
            optionLabel="name"
            optionValue="id"
            label="Industry"
            selectedData={industry}
            setSelectedData={setIndustry}
          />
        </Grid>
        <Grid item xs={6}>
          <MultiDropdownApi
            showAll={true}
            apiPath="risk-job-task"
            optionLabel="name"
            optionValue="id"
            label="Job Task"
            selectedData={jobTask}
            setSelectedData={setJobTask}
          />
        </Grid>
        <Grid item xs={12}>
          <QuillEditor
            label="Body"
            content={content}
            setContent={setContent}
            toast={modalProps.toast}
            ref={quillEditorRef}
            onPlaceholdersLoaded={validateForm}
          />
          {placeholderErrors.length > 0 && (
            <div
              style={{
                color: "black",
                background: "rgba(255,191,0,0.22)",
                padding: "20px 20px 10px 20px",
                marginTop: 10,
                borderRadius: 5,
              }}
            >
              <span style={{ fontWeight: "bold" }}>
                {" "}
                ⚠️ The following placeholders do not exist:
              </span>{" "}
              <ul>
                {placeholderErrors.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </Grid>
      </Grid>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions
          style={{ marginTop: 15 }}
          sx={{ alignSelf: "flex-end", pt: 2 }}
        >
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => addIndustry()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
